import React, { useEffect, useState } from 'react';
import { Table, Container, Row, Col, Spinner } from 'react-bootstrap';
import axios from 'axios';

const AdminUsersPage = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch user data from the API
        axios.get('http://donerightdecals.com/api/all-users')
            .then(response => {
                setUsers(response.data.allusers);
                setLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the user data!', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </Container>
        );
    }

    return (
        <Container className="mt-5">
            <Row>
                <Col>
                    <h2 className="mb-4">All Users</h2>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Is Admin</th>
                                <th>Email Verified At</th>
                                <th>Created At</th>
                                <th>Updated At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map(user => (
                                <tr key={user.id}>
                                    <td>{user.id}</td>
                                    <td>{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>{user.is_admin ? 'Yes' : 'No'}</td>
                                    <td>{user.email_verified_at ? user.email_verified_at : 'Not Verified'}</td>
                                    <td>{new Date(user.created_at).toLocaleString()}</td>
                                    <td>{new Date(user.updated_at).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container>
    );
};

export default AdminUsersPage;
